import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';

import { ClockinResponse, ClockinPageQuery, ClockinReportData, UserClockReportQuery } from '@business/entities/clockin';
import { ClockinReportsAPI } from '@business/api/clockin_reports';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserId } from '@business/entities/account';
import { ClockinTeamDetailsFormData } from '@modules/clockin/ClockinTeamDetailsOverlay/Tabs/ClockinTeamsTab';
import { TeamId } from '@business/entities/team';
import { ClockinReportFormData } from '@modules/clockin/ClockinExportModal/ClockinExportModal';

export class ClockinReportsBloc extends BaseBloc {
  private readonly reportRepo = new Repository<ClockinResponse>({
    getItemId: report => report.id,
  });

  // readonly reports$ = this.reportRepo.items$;

  readonly report$ = new BehaviorSubject<ClockinReportData[]>([]);
  readonly requestId$ = new BehaviorSubject<number>(0);

  onReset() {
    this.reportRepo.reset();
  }

  fetchReport = (params: ClockinPageQuery) => {
    this.requestId$.next(params.requestId!);
    return ClockinReportsAPI.getAll(params).pipe(
      tap(r => (r.requestId === this.requestId$.value.toString() ? this.report$.next(r.data) : null)),
      handleMessage({ error: requestMessage('fetch_clockin_report_error') }),
    );
  };

  fetchUserReport = (userId: UserId, params: UserClockReportQuery) => {
    return ClockinReportsAPI.getUserReport(userId, params).pipe(handleMessage({ error: requestMessage('fetch_clockin_report_error') }));
  };

  fetchTeamReport = (teamId: TeamId, params: ClockinTeamDetailsFormData) => {
    return ClockinReportsAPI.getTeamReport(teamId, params).pipe(handleMessage({ error: requestMessage('fetch_clockin_report_error') }));
  };

  fetchUserTimesheet = (userId: UserId, params: ClockinTeamDetailsFormData) => {
    return ClockinReportsAPI.getUserTimesheet(userId, params).pipe(handleMessage({ error: requestMessage('fetch_clockin_report_error') }));
  };

  export = (params: ClockinReportFormData) => {
    return ClockinReportsAPI.exportReport(params).pipe(handleMessage({ error: requestMessage('fetch_clockin_report_error') }));
  };

  // syncCurrency = () => {
  //   return CurrencyAPI.syncCurrencies().pipe(this.currencyRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_currency_error') }));
  // };

  // createCurrency = (companyId: CompanyId, data: Partial<CurrencyResponse>) => {
  //   return CurrencyAPI.createCurrency(companyId, data).pipe(
  //     this.currencyRepo.ops.addOne(item => item),
  //     handleMessage({
  //       type: requestMessage('create_category'),
  //     }),
  //   );
  // };

  // updateCurrency = (currencyId: CurrencyID, rate: number) => {
  //   return CurrencyAPI.updateCurrency(currencyId, rate).pipe(
  //     handleMessage({
  //       type: requestMessage('create_category'),
  //     }),
  //   );
  // };

  // deleteCurrency = (id: CurrencyID) => {
  //   return showDeleteConfirmation('Delete Currency', `Do you really want to remove this currency?`).pipe(
  //     switchMap(() => CurrencyAPI.deleetCurrency(id)),
  //     this.currencyRepo.ops.removeOne(() => id),
  //     handleMessage({
  //       type: requestMessage('delete_category'),
  //     }),
  //   );
  // };
}
